// extracted by mini-css-extract-plugin
export var core = "Grid-module--core--462df";
export var wide = "Grid-module--wide--a4030";